import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import SessionProp from '../propTypes/sessionProp';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import MoreInfoSession from '../../shared/MoreInfoSession';
import HardSkillProp from '../../challenges/propTypes/hardSkillProp';
import TenantProp from '../../../commonComponents/propTypes/tenantProp';
import ProductProp from '../../shop/propTypes/productProp';
import ShippingProviderProp from '../../shop/propTypes/shippingProviderProp';
import OrganizationProp from '../../../commonComponents/propTypes/organizationProp';
import CurrencyProp from '../../profile/propTypes/currencyProp';

function AcademySessionToggle({
  t,
  session,
  countries,
  ownerId,
  languages,
  hardSkills,
  directSellingActive,
  products,
  shippingProviders,
  organization,
  isFinished,
  currencies,
  canSeeParticipants,
}) {
  return (
    <>
      <MoreInfoSession
        startCollapsed
        session={session}
        title={t('sessionDetails_about')}
        countries={countries}
        ownerId={ownerId}
        languages={languages}
        hardSkills={hardSkills}
        directSellingActive={directSellingActive}
        products={products}
        shippingProviders={shippingProviders}
        organization={organization}
        isFinished={isFinished}
        currencies={currencies}
        canSeeParticipants={canSeeParticipants}
      />
      <div />
    </>
  );
}

AcademySessionToggle.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  ownerId: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType))
    .isRequired,
  directSellingActive: PropTypes.shape(TenantProp.propType),
  products: PropTypes.shape(ProductProp.propType).isRequired,
  shippingProviders: PropTypes.arrayOf(
    PropTypes.shape(ShippingProviderProp.propType),
  ).isRequired,
  organization: PropTypes.shape(OrganizationProp.propTypes).isRequired,
  isFinished: PropTypes.bool,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  canSeeParticipants: PropTypes.bool,
};

AcademySessionToggle.defaultProps = {
  directSellingActive: null,
  isFinished: false,
  canSeeParticipants: false,
};

export default translate(AcademySessionToggle);
